import React from 'react';
import { Link } from 'react-router-dom';
import SliderComponent from '../pages/SliderComponent';
import ClientsCarousel from '../pages/ClientsCarousel';

const Home = () => {

    return (
        <>
            {/* <!-- Slider Area Start --> */}
            <SliderComponent />
            {/* Slider Area End */}
            <section className="bleezy-about-page" style={{ marginTop: '30px' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="about-right">
                                <img src="assets/img/Gallery/Bouncer3.jpeg" alt="about image" />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="about-left" style={{ marginLeft: '30px' }}>
                                <h2 className='heading-with-border'>Welcome to Octopuss Security</h2>
                                <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                                    OCTOPUSS SECURITY, a premier ISO 9001:2015 Certified Security Group Company, provides wide range of Security, Manpower and  House-Keeping related services. It includes – Armed & Unarmed Manned Guarding Services; Cash Van Service; Bouncer & Bodyguard Service; Event Security Management; Skilled & Unskilled Manpower Service; Temporary Staffing; Facility Management; Housekeeping Services.
                                </p>
                                <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                                    We are the best security guards service provider company in India. We are passionate about our work and truly believe in offering best of services to our clients at the most affordable cost. We continuously upgrade and improve ourselves to give you best in security. Our philosophy is giving “Security beyond Guarding” experience to our clients. We truly believe that Security is much more than mere deployment and monitoring of guards. It involves thorough identification of roles and responsibilities of each guard and providing training to enable them to perform their duties in most efficient and productive manner. We aim to make your investment on security more productive by supplementing security guard responsibilities with important roles in the best interest of the company and with an aim to relieve the management completely of security and all allied problems. Our security guard service is most sought after services in India.
                                </p>
                                <Link className="bleezy-btn" to="/About">Read more</Link>
                            </div>
                        </div>

                    </div>
                </div>
            </section>





            {/* <!-- Count Area Start --> */}
            <section className="bleezy-count-area" style={{ paddingTop: '30px', paddingBottom: '30px', marginTop: '30px' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="counts-text">
                                <h3>We are ready to provide security in resonable price and guarantee your safety in any situation in your life </h3>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-2 col-sm-2">
                            <div className="count-box">
                                <h3 className="counter">300+</h3>
                                <h4>Satified<span>Clients</span></h4>
                            </div>
                        </div>
                        <div className="col-md-2 col-sm-2">
                            <div className="count-box">
                                <h3 className="counter">98%</h3>
                                <h4>Retention  <span>Rate</span></h4>
                            </div>
                        </div>
                        <div className="col-md-2 col-sm-2">
                            <div className="count-box">
                                <h3 className="counter">1100+</h3>
                                <h4>Manpower </h4>
                            </div>
                        </div>
                        <div className="col-md-2 col-sm-2">
                            <div className="count-box">
                                <h3 className="counter">100%</h3>
                                <h4>Compliance</h4>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-3">
                            <div className="count-box">
                                <h3 className="counter">5</h3>
                                <h4>Business Verticals</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Count Area End --> */}

            <section class="bleezy-blog-page-area" style={{ marginTop: '30px', background: '#ebe6e6', paddingTop: '15px', paddingBottom: '15px' }}>
                <div class="container">
                    <div class="mid-title text-center  mb-5 "><h2 class="heading-with-border">Security Services</h2><p className="octo-para">Security is our core business and we are very passionate about our work. Manned Guarding is no longer a one-size-fits-all solution. The expectation of security personnel capabilities have evolved and vary widely,
                        at times even within the same business. Depending on the size, location, nature and requirements of the client’s business, Octopuss Security customises it’s solution after understanding client’s pain points. Our security company is having presence at India, Pune, Ahmedabad, Hyderabad and Bangalore. We provide wide range of Security Service which caters to all type of Security needs.</p>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-sm-4">
                            <div class="service-card single-gallery-img">
                                <div class="service-image">
                                    <img src="assets/img/Gallery/Securityguard2.jpeg" alt="Security Guard" />
                                    <h3 class="service-title">SECURITY GUARD</h3>
                                </div>

                                <p class="service-text">
                                    Get trained Security Guard, Supervisor and Security Officer at competitive rate
                                    with excellent track record and PCC verified.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div class="service-card single-gallery-img">
                                <div class="service-image">
                                    <img src="assets/img/Gallery/Bouncer.jpeg" alt="Security Guard" />
                                    <h3 class="service-title">BOUNCER & BODYGUARD</h3>
                                </div>

                                <p class="service-text">
                                    Hire professional, trained and well build Bouncers and Bodyguard for your short term or long term security needs.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div class="service-card single-gallery-img">
                                <div class="service-image">
                                    <img src="assets/img/Gallery/Escort1.jpg" alt="Security Guard" />
                                    <h3 class="service-title">ESCORT GUARD</h3>
                                </div>

                                <p class="service-text">
                                    Hire Professional Escort Guard for safeguarding your female employees during commuting at night in compliance with S&E Act.
                                </p>
                            </div>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-md-4 col-sm-4">
                            <div class="service-card single-gallery-img">
                                <div class="service-image">
                                    <img src="assets/img/slider-1.jpg" alt="Security Guard" />
                                    <h3 class="service-title">EVENT SECURITY</h3>
                                </div>

                                <p class="service-text">
                                    Looking for Quick Short Term Security Services for an event? We have experience and expertise in event management.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div class="service-card single-gallery-img">
                                <div class="service-image">
                                    <img src="assets/img/Gallery/Tourist.jpg" alt="Security Guard" />
                                    <h3 class="service-title">TOURIST SECURITY</h3>
                                </div>

                                <p class="service-text">
                                    Security concerns while travelling to India? Relax and allow us to safeguard and guide you to make your journey safe and memorable.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div class="service-card single-gallery-img">
                                <div class="service-image">
                                    <img src="assets/img/gallery-2.jpg" alt="Security Guard" />
                                    <h3 class="service-title">SCHOOL SECURITY</h3>
                                </div>

                                <p class="service-text">
                                    Hire professional, trained and well build Bouncers and Bodyguard for your short term or long term security needs.
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <section class="bleezy-blog-page-area" style={{ marginTop: '30px', background: '#ebe6e6', paddingTop: '15px', paddingBottom: '15px' }}>
                <div class="container">
                    <div class="mid-title text-center  mb-5 "><h2 class="heading-with-border">Facility Management Service</h2><p className="octo-para">
                        Octopuss Facility Management services are unique due to our in-depth understanding of customers’ individual needs, and the depth of experience upon which we have built best practices and our company. Our Facility Management Company in India, provides Housekeeping Service, Office Boy Service, Pantry Boy Service and Labour Service. By hiring our services you will get complete array of supporting services such as facility and security services under one roof. By having a Single Point Of Contact (SPOC) for all your back office needs, you can breath easy and delegate all the task to us.</p>
                    </div>
                    <div className="row">
                        <div className="col-md-3 col-sm-3">
                            <div class="service-card single-gallery-img">
                                <div class="service-image">
                                    <img src="assets/img/abt-img.jpg" alt="Security Guard" />
                                    <h3 class="service-title">Housekeeping Service</h3>
                                </div>

                                <p class="service-text">
                                    Get the best Housekeeping Service at reasonable rate along with bouquet of related services under one roof.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-3">
                            <div class="service-card single-gallery-img">
                                <div class="service-image">
                                    <img src="assets/img/Gallery/Officeboy.jpg" alt="Security Guard" />
                                    <h3 class="service-title">Office Boy</h3>
                                </div>

                                <p class="service-text">
                                    Hire Office Boy service on monthly contractual basis at competitive rate to support your staff in carrying out routine task.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-3">
                            <div class="service-card single-gallery-img">
                                <div class="service-image">
                                    <img src="assets/img/Gallery/Pantry2.jpeg" alt="Security Guard" />
                                    <h3 class="service-title">Pantry Boy</h3>
                                </div>

                                <p class="service-text">
                                    Hire trained and uniformed Pantry Boy Service at competitive rate and give complete makeover to your 
                                </p>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-3">
                            <div class="service-card single-gallery-img">
                                <div class="service-image">
                                    <img src="assets/img/slider-3.jpg" alt="Security Guard" />
                                    <h3 class="service-title">Office Support Services</h3>
                                </div>

                                <p class="service-text">
                                    Looking for Quick Short Term Security Services for an event? We have experience and expertise in event management.
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* <div className="row">

                        <div className="col-md-3 col-sm-3">
                            <div class="service-card single-gallery-img">
                                <div class="service-image">
                                    <img src="assets/img/Gallery/driver.jpg" alt="Security Guard" />
                                    <h3 class="service-title">Canpactual Staffing & Driver</h3>
                                </div>

                                <p class="service-text">
                                    Security concerns while travelling to India? Relax and allow us to safeguard and guide you to make your journey safe and memorable.
                                </p>
                            </div>
                        </div>
                    </div> */}

                </div>
            </section>

            <section class="bleezy-blog-page-area" style={{ marginTop: '30px', background: '#ebe6e6', paddingTop: '15px', paddingBottom: '15px' }}>
                <div class="container">
                    <div class="mid-title text-center  mb-5 "><h2 class="heading-with-border">Manpower Services</h2><p className="octo-para">
                        We provide all type of Manpower Services required for Back Office, Front Office and Labour Service. More and more organisation are successfully hiring their Human Resource requirement on contract basis, as it protects them against inefficiency of staff, high replacement cost, compliance issue and complexity of labour laws.</p>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-sm-4">
                            <div class="service-card single-gallery-img">
                                <div class="service-image">
                                    <img src="assets/img/gallery-1.jpg" alt="Security Guard" />
                                    <h3 class="service-title">Front & back office</h3>
                                </div>

                                <p class="service-text">
                                    Hire front office, back office Manpower and labour service  on contract basis like Plumber, Electrician, Driver, Gardener, etc.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div class="service-card single-gallery-img">
                                <div class="service-image">
                                    <img src="assets/img/gallery-2.jpg" alt="Security Guard" />
                                    <h3 class="service-title">Temp Staffing</h3>
                                </div>

                                <p class="service-text">
                                    Hire Temporary staff and join thousand of companies getting benefited through contract staffing amd save time, effort & money.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div class="service-card single-gallery-img">
                                <div class="service-image">
                                    <img src="assets/img/Gallery/event.avif" alt="Security Guard" />
                                    <h3 class="service-title">Event Staff</h3>
                                </div>

                                <p class="service-text">
                                    Get event anchors, models, exhibition attendants, tele callers, mall promoters, etc. as per your need for all type of events.
                                </p>
                            </div>
                        </div>

                    </div>


                </div>
            </section>

            <section className="bleezy-about-page" style={{ marginTop: '30px' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="about-right">
                                <img src="assets/img/Gallery/Bouncer2.jpeg" alt="about image" />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="about-left" style={{ marginLeft: '30px' }}>
                                <h2 className='heading-with-border'>Why Choose Us?</h2>
                                <ul class="list">
                                    <li className='octo-para'><i class="fa fa-check theme-color"></i> Free Survey of your site and input from our security expert on various security parameters.</li>
                                    <li className='octo-para'><i class="fa fa-check theme-color"></i> Flexible budget option by offering tailor made quotations.</li>
                                    <li className='octo-para'><i class="fa fa-check theme-color"></i> Trained Guards plus regular onsite training to keep sharpening their job-related skill.</li>
                                    <li className='octo-para'><i class="fa fa-check theme-color"></i> 100% compliance with monthly report submission.</li>
                                    <li className='octo-para'><i class="fa fa-check theme-color"></i> Remote monitoring of security guards through live tracking app.</li>
                                    <li className='octo-para'><i class="fa fa-check theme-color"></i> On time payment of salary irrespective of overdue payment status.</li>
                                    <li className='octo-para'><i class="fa fa-check theme-color"></i> Regular day and night patrolling.</li>
                                    <li className='octo-para'><i class="fa fa-check theme-color"></i> Replacement of non-performing guards without any question asked.</li>
                                    <li className='octo-para'><i class="fa fa-check theme-color"></i> Zero deficiency throughout the year.</li>
                                    <li className='octo-para'><i class="fa fa-check theme-color"></i> Committed to resolve any issue within 48 hours.</li>
                                    <li className='octo-para'><i class="fa fa-check theme-color"></i> We constantly evolve and upgrade to give you the best security experience.</li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section class="bleezy-blog-page-area" style={{ marginTop: '30px', paddingTop: '15px', paddingBottom: '15px', background: '#ebe6e6' }}>
                <div class="container">
                    <div class="mid-title text-center  mb-5 "><h2 class="heading-with-border">Our Happy Clients</h2>
                        <ClientsCarousel />
                    </div>
                </div>
            </section>



        </>
    )
}

export default Home;